import React from 'react';

const PreHeader: React.FC = () => (
  <div
    className="w-full overflow-hidden py-2 sm:py-2.5"
    style={{ background: 'linear-gradient(90deg, #B31942 0%, #B31942 35%, #0A3161 65%, #0A3161 100%)' }}
  >
    <div className="flex animate-ticker whitespace-nowrap will-change-transform">
      {Array.from({ length: 20 }).map((_, i) => (
        <span
          key={i}
          className="inline-flex items-center text-white/90 text-xs sm:text-sm font-bold uppercase tracking-wider mx-4 shrink-0"
        >
          Do Zero ao Mercado Americano
        </span>
      ))}
    </div>
  </div>
);

export default PreHeader;
